export default function Footer() {
  const currentYear = new Date().getFullYear();

  const columns = [
    {
      heading: "Quick Links",
      links: ["About Us", "Our Team", "Projects", "Careers", "Blog", "FAQs"],
    },
    {
      heading: "Services",
      links: ["Residential", "Commercial", "Land & Plots", "Investment Advisory", "Home Loan Assist", "Legal Guidance"],
    },
    {
      heading: "Localities",
      links: ["New Town", "Rajarhat", "Alipore", "Salt Lake", "Tollygunge", "EM Bypass"],
    },
  ];

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600&family=Playfair+Display:ital,wght@0,400;0,600;0,700&display=swap');

        .sr-footer {
          background: #030a14;
          border-top: 1px solid rgba(212,175,55,0.1);
          position: relative; overflow: hidden;
        }
        .sr-footer::before {
          content: '';
          position: absolute; top: 0; left: 0; right: 0; height: 1px;
          background: linear-gradient(90deg, transparent, #D4AF37, transparent);
          opacity: 0.4;
        }

        .sr-footer-top {
          max-width: 1240px; margin: 0 auto;
          padding: 80px 56px 56px;
          display: grid;
          grid-template-columns: 2.2fr 1fr 1fr 1fr;
          gap: 56px;
          border-bottom: 1px solid rgba(255,255,255,0.04);
        }

        .sr-footer-brand-logo {
          font-family: 'Playfair Display', serif;
          font-size: 24px; font-weight: 700;
          color: #D4AF37; margin-bottom: 6px;
          display: flex; align-items: center; gap: 10px;
        }
        .sr-footer-brand-logo-icon {
          width: 34px; height: 34px;
          border: 1.5px solid rgba(212,175,55,0.5);
          display: flex; align-items: center; justify-content: center;
          font-size: 15px; color: #D4AF37;
        }
        .sr-footer-brand-logo span { color: #c0b8a8; font-weight: 400; }

        .sr-footer-tagline {
          font-family: 'Playfair Display', serif;
          font-style: italic; font-size: 13px;
          color: rgba(212,175,55,0.5); margin-bottom: 20px;
          letter-spacing: 0.5px;
        }

        .sr-footer-desc {
          font-family: 'DM Sans', sans-serif;
          font-size: 13px; line-height: 1.85;
          color: #8a8070; max-width: 320px; margin-bottom: 28px;
        }

        .sr-footer-socials {
          display: flex; gap: 10px;
        }
        .sr-footer-social-btn {
          width: 36px; height: 36px;
          border: 1px solid rgba(212,175,55,0.2);
          background: transparent;
          display: flex; align-items: center; justify-content: center;
          cursor: pointer; transition: all 0.2s; color: #5a5040;
        }
        .sr-footer-social-btn:hover {
          border-color: #D4AF37; color: #D4AF37;
          background: rgba(212,175,55,0.06);
        }

        .sr-footer-col-heading {
          font-family: 'DM Sans', sans-serif;
          font-size: 10px; font-weight: 700; letter-spacing: 2.5px;
          text-transform: uppercase; color: #5a5040;
          margin-bottom: 22px; padding-bottom: 12px;
          border-bottom: 1px solid rgba(255,255,255,0.04);
        }

        .sr-footer-col-links {
          list-style: none; margin: 0; padding: 0;
        }
        .sr-footer-col-links li { margin-bottom: 11px; }
        .sr-footer-col-links a {
          font-family: 'DM Sans', sans-serif;
          font-size: 13px; color: #8a8070;
          text-decoration: none; transition: color 0.2s;
          display: flex; align-items: center; gap: 0;
        }
        .sr-footer-col-links a::before {
          content: ''; width: 0; height: 1px;
          background: #D4AF37; transition: width 0.2s;
          margin-right: 0;
        }
        .sr-footer-col-links a:hover { color: #D4AF37; }
        .sr-footer-col-links a:hover::before { width: 10px; margin-right: 6px; }

        .sr-footer-middle {
          max-width: 1240px; margin: 0 auto; padding: 40px 56px;
          display: grid; grid-template-columns: repeat(3, 1fr); gap: 32px;
          border-bottom: 1px solid rgba(255,255,255,0.04);
        }

        .sr-footer-contact-item {
          display: flex; align-items: flex-start; gap: 14px;
        }
        .sr-footer-contact-icon {
          width: 36px; height: 36px; flex-shrink: 0;
          border: 1px solid rgba(212,175,55,0.2);
          display: flex; align-items: center; justify-content: center;
          color: #D4AF37;
        }
        .sr-footer-contact-label {
          font-family: 'DM Sans', sans-serif;
          font-size: 10px; font-weight: 600; letter-spacing: 1.5px;
          text-transform: uppercase; color: #4a4030; margin-bottom: 4px;
        }
        .sr-footer-contact-value {
          font-family: 'DM Sans', sans-serif;
          font-size: 14px; color: #8a8070; font-weight: 500;
        }
        .sr-footer-contact-value a {
          color: #8a8070; text-decoration: none; transition: color 0.2s;
        }
        .sr-footer-contact-value a:hover { color: #D4AF37; }

        .sr-footer-bottom {
          max-width: 1240px; margin: 0 auto; padding: 24px 56px;
          display: flex; justify-content: space-between; align-items: center;
          flex-wrap: wrap; gap: 12px;
        }
        .sr-footer-copy {
          font-family: 'DM Sans', sans-serif;
          font-size: 12px; color: #5a5040;
        }
        .sr-footer-legal {
          display: flex; gap: 20px;
        }
        .sr-footer-legal a {
          font-family: 'DM Sans', sans-serif;
          font-size: 11px; color: #5a5040;
          text-decoration: none; transition: color 0.2s;
        }
        .sr-footer-legal a:hover { color: #D4AF37; }

        .sr-footer-rera {
          display: inline-flex; align-items: center; gap: 8px;
          padding: 6px 14px;
          border: 1px solid rgba(212,175,55,0.15);
          font-family: 'DM Sans', sans-serif;
          font-size: 11px; color: #5a5040; letter-spacing: 1px;
          text-transform: uppercase;
        }

        @media (max-width: 900px) {
          .sr-footer-top { grid-template-columns: 1fr 1fr; padding: 48px 24px 40px; gap: 36px; }
          .sr-footer-middle { grid-template-columns: 1fr; padding: 32px 24px; }
          .sr-footer-bottom { padding: 20px 24px; flex-direction: column; align-items: flex-start; }
        }
        @media (max-width: 480px) {
          .sr-footer-top { grid-template-columns: 1fr; }
        }
      `}</style>

      <footer className="sr-footer">
        <div className="sr-footer-top">
          <div>
            <div className="sr-footer-brand-logo">
              <div className="sr-footer-brand-logo-icon">N</div>
              NextFront<span>Properties</span>
            </div>
            <p className="sr-footer-tagline">Trusted Since 1990 · The City of Joy</p>
            <p className="sr-footer-desc">
              Kolkata's leading real estate consultancy with 35+ years of trusted service,
              300+ projects marketed, and a legacy of transparent, client-first property transactions.
            </p>
            <div className="sr-footer-socials">
              <button className="sr-footer-social-btn" title="Facebook">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
                </svg>
              </button>
              <button className="sr-footer-social-btn" title="Instagram">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
                </svg>
              </button>
              <button className="sr-footer-social-btn" title="YouTube">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 0 0 1.46 6.42 29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58 2.78 2.78 0 0 0 1.95 1.96C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 0 0 1.95-1.96A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z"/>
                  <polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02"/>
                </svg>
              </button>
              <button className="sr-footer-social-btn" title="LinkedIn">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6zM2 9h4v12H2z"/>
                  <circle cx="4" cy="4" r="2"/>
                </svg>
              </button>
            </div>
          </div>

          {columns.map(col => (
            <div key={col.heading}>
              <h4 className="sr-footer-col-heading">{col.heading}</h4>
              <ul className="sr-footer-col-links">
                {col.links.map(l => <li key={l}><a href="#">{l}</a></li>)}
              </ul>
            </div>
          ))}
        </div>

        <div className="sr-footer-middle">
          <div className="sr-footer-contact-item">
            <div className="sr-footer-contact-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.6 3.53 2 2 0 0 1 3.56 1.35h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 9a16 16 0 0 0 6 6l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21.73 16.92z"/>
              </svg>
            </div>
            <div>
              <p className="sr-footer-contact-label">Call Us</p>
              <p className="sr-footer-contact-value">
                <a href="tel:+919051740000">+91 90517 40000</a>
              </p>
            </div>
          </div>

          <div className="sr-footer-contact-item">
            <div className="sr-footer-contact-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                <circle cx="12" cy="10" r="3"/>
              </svg>
            </div>
            <div>
              <p className="sr-footer-contact-label">Office</p>
              <p className="sr-footer-contact-value">Park Street & Salt Lake, Kolkata</p>
            </div>
          </div>

          <div className="sr-footer-contact-item">
            <div className="sr-footer-contact-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                <polyline points="22,6 12,13 2,6"/>
              </svg>
            </div>
            <div>
              <p className="sr-footer-contact-label">Email</p>
              <p className="sr-footer-contact-value">
                <a href="mailto:info@nextfrontproperties.com">info@nextfrontproperties.com</a>
              </p>
            </div>
          </div>
        </div>

        <div className="sr-footer-bottom">
          <p className="sr-footer-copy">© {currentYear} NextFrontProperties Pvt. Ltd. All Rights Reserved.</p>
          <div className="sr-footer-rera">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="2">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
            </svg>
            RERA Registered · West Bengal
          </div>
          <div className="sr-footer-legal">
            <a href="#">Privacy Policy</a>
            <a href="#">Terms of Use</a>
            <a href="#">Disclaimer</a>
          </div>
        </div>
      </footer>
    </>
  );
}